import { HiOutlineTrash } from 'react-icons/hi'
import { Button } from '..'

const TrashButton = ({ onClick }) => {
  return (
    <Button onClick={onClick} color={'#D3384B'}>
      <HiOutlineTrash style={{ position: 'absolute' }} />
    </Button>
  )
}
export default TrashButton
